import axios from 'axios'
import Vue from 'vue'
import qs from 'qs';
import Router from '@/router';
import {
	MessageBox,
	Message,
	Loading
} from 'element-ui';

import config from '@/constant/config'

import common from '@/utils/common'

import {
	userLogout
} from '@/http/api/user'

console.log('当前项目:', config.itemName, config.BASE_URL, 'q_liangxun-official-website')

//创建axios
const service = axios.create({
	baseURL: config.BASE_URL,
	timeout: 6000000,
	withCredentials: true
})

var messageBoxCount = 0,
	loadingCount = 0, //打开 laoding  的个数
	loading;
var tokenPromise = null;
var notGetToken = [`${config.USER_BASE_URL}/user/get-login-status`, '/login/logout', '/vip/app_config'];

// 动态判断（不需要登录但可以查看的页面）
const notLoginPage = () => {
	const hash = window.location.hash
	const cleanPath  = hash.split('?')[0];
	return cleanPath === '#/home' || cleanPath === '#/' || cleanPath === '' || cleanPath === '#/vip'
}

// loading开始 方法
function startLoading() {
	loadingCount++;
	loading = Loading.service({
		lock: true,
		text: '拼命加载中...',
		spinner: 'el-icon-loading', // 自定义图标
		background: 'rgba(0, 0, 0, 0.2)',
		customClass: 'loadingClass'
	})
}

// loading结束 方法
function loadingClose() {
	loadingCount--;
	loading.close()
}

function logout() {
	window.dispatchEvent(new CustomEvent('unauthorized'))
	userLogout().then().catch(() => {})
}

async function getToken(refresh = false) {
	if (tokenPromise == null || refresh) {
		tokenPromise = new Promise((resolve, reject) => {
			service.get(`${config.USER_BASE_URL}/user/get-login-status`, {
				headers: {
					Token: sessionStorage.getItem('token')
				}
			}).then(res => {
				if (res.data.token) {
					sessionStorage.setItem('token', res.data.token)
					resolve(res.data.token)
				} else {
					sessionStorage.removeItem('token')
					logout()
					reject(new Error('获取token失败'))
				}
			}).catch((err) => {
				logout()
				reject(err)
			})
		})
	}
	return tokenPromise
}

// 请求拦截器
service.interceptors.request.use(async (conf) => {
	if (conf.headers['Content-Type']) {
		if (conf.headers['Content-Type'] == 'application/x-www-form-urlencoded') { //表单格式
			conf.data = qs.stringify(conf.data)
		}
	} else { //JSON字符串 格式
		conf.headers['Content-Type'] = 'application/json;charset=utf-8'
		conf.data = JSON.stringify(conf.data)
	}
	
	if (conf.base == 'user') conf.baseURL = config.USER_BASE_URL
	if (conf.requestLoading) {
		startLoading();
	}
	if(sessionStorage.getItem('token')) conf.headers.Token = sessionStorage.getItem('token');
	if (notGetToken.indexOf(conf.url) == -1) {
		let token = await getToken()
		conf.headers.Token = token;
	}

	return conf
}, error => {
	Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use((res) => {
	// console.log('响应拦截器：', res)
	if (res.config.requestLoading) {
		loadingClose();
	}

	// 不做判断,直接返回
	if (res.config.isBack) return res.data

	// 未登录
	if (res.data.code == 1 || res.data.code == 4) {
		sessionStorage.removeItem('token')
		window.dispatchEvent(new CustomEvent('unauthorized'))
		setTimeout(() => {
			// 检查是否在首页或正在跳转首页
			if (!notLoginPage()) {
				// 非首页显示弹窗
				if (messageBoxCount == 0) {
					messageBoxCount++
					MessageBox('您未进行登录或登录信息已过期, 去登录?', '提示', {
						type: 'warning'
					}).then(() => {
						messageBoxCount--
						common.goLogin()
					}).catch(() => {
						messageBoxCount--
					});
				}
			}
		}, 100)
		return Promise.reject(res)
	}

	// 2  无权限     5  已过期
	if (res.data.code == 2 || res.data.code == 5) {
		if(window.location.hash != '#/noPermissionAnddueDate') Router.push(`/noPermissionAnddueDate?code=${res.data.code}`)
		return Promise.reject(res)
	}
	
	if (res.data.code !== 0) {
		Message.error(res.data.msg || '请求数据失败')
		return Promise.reject(res)
	}

	return res.data

}, (error) => {
	if (error.config.requestLoading) {
		loadingClose();
	}
	if(!notLoginPage()) {
		Message.error(error.toString())
	}
	return Promise.reject(error)
})

export default service